import { WarrantyPart } from '@api/types';
import { useWarrantyClaimContext } from '@components';
import { useFieldArray } from 'react-hook-form';

const defaultPart: WarrantyPart = { quantity: 1, id: 0 };

export const usePartsManager = () => {
  const { form } = useWarrantyClaimContext();
  const { fields, remove } = useFieldArray({
    control: form.control,
    name: 'parts',
  });
  const parts = form.watch('parts');

  const addPart = () => {
    const currentParts = form.getValues('parts') || [];
    form.setValue('parts', [...currentParts, { ...defaultPart, id: 0 }]);
  };

  const removePart = (index: number) => {
    form.clearErrors(`parts.${index}.quantity`);
    remove(index);
  };

  return {
    addPart,
    removePart,
    fields,
    parts,
  };
};
